//@flow
import React, { Component } from 'react';
import {
  IconWithTextDiv,
  CustomInfoTooltip,
  LabelP
} from './IconWithTextStyles';

type Props = {
  label: string,
  message: string,
  showTooltip: () => void,
  activeTooltip: string,
  tooltipName: string,
  className?: string,
  icon?: string,
  iconColor?: string,
  labelColor?: string,
  smallIcon?: boolean,
  iconRight?: boolean
};
export default class IconWithText extends Component<Props> {
  render() {
    return (
      <IconWithTextDiv
        className={this.props.className}
        iconRight={this.props.iconRight}
      >
        <CustomInfoTooltip
          message={this.props.message}
          showTooltip={this.props.showTooltip}
          activeTooltip={this.props.activeTooltip}
          tooltipName={this.props.tooltipName}
          icon={this.props.icon}
          iconColor={this.props.iconColor}
          smallIcon={this.props.smallIcon}
          iconRight={this.props.iconRight}
        />
        <LabelP color={this.props.labelColor}>{this.props.label}</LabelP>
      </IconWithTextDiv>
    );
  }
}
